import buildMeta from '@/router/utils/buildMeta'

const routes = [
  {
    name: 'resume-builder',
    path: '/resume-builder',
    component: () => import('@/pages/ResumeBuilder/ResumeBuilder.vue'),
    redirect: '/resume-builder/start',
    children: [
      {
        path: 'start',
        name: 'resume-builder-start',
        component: () => import('@/pages/ResumeBuilder/components/Start.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
          pageTitle: 'ResumeBuilder',
          title: 'Resume builder - Jobscan',
        }),
      },
      {
        path: 'select-template',
        name: 'resume-builder-template-selector',
        component: () =>
          import('@/pages/ResumeBuilder/components/TemplateSelector.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
          pageTitle: 'ResumeBuilder',
          title: 'Resume builder - Jobscan',
        }),
      },
      {
        path: 'profile-info',
        name: 'resume-builder-profile',
        component: () =>
          import('@/pages/ResumeBuilder/components/ProfileInfo.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
          pageTitle: 'ResumeBuilder',
          title: 'Resume builder - Jobscan',
        }),
      },
      {
        path: 'experience',
        name: 'resume-builder-experience',
        component: () =>
          import('@/pages/ResumeBuilder/components/WorkExperience.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
          pageTitle: 'ResumeBuilder',
          title: 'Resume builder - Jobscan',
        }),
      },
      {
        path: 'education',
        name: 'resume-builder-education',
        component: () =>
          import('@/pages/ResumeBuilder/components/Education.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
          pageTitle: 'ResumeBuilder',
          title: 'Resume builder - Jobscan',
        }),
      },
      {
        path: 'additional',
        name: 'resume-builder-additional',
        component: () =>
          import('@/pages/ResumeBuilder/components/Additional.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
          pageTitle: 'ResumeBuilder',
          title: 'Resume builder - Jobscan',
        }),
      },
      {
        path: 'done',
        name: 'resume-builder-done',
        component: () =>
          import('@/pages/ResumeBuilder/components/Done.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
          pageTitle: 'ResumeBuilder',
          title: 'Resume builder - Jobscan',
        }),
      }
    ],
  },
]

export default routes
